

import React, { Component } from 'react';
import _memoize from 'lodash.memoize';
import { FormModal } from '../../ui-kit';
import ChangesForm, { OTHER_REASON } from '../../common/components/ChangesForm';
import './styles/_changes_modal.scss';

const INITIAL_STATE = {
  selectedReasons: [],
  otherReason: ''
};






















class ChangesModal extends Component {
  static defaultProps = {
    additionalReasonTitle: 'Reasons'
  };

  state = INITIAL_STATE;

  componentDidUpdate({ visible: prevVisible }) {
    const { visible } = this.props;

    if (visible || !prevVisible) {
      return;
    }

    this.resetState();
  }

  onCheck = _memoize((value) => () => {
    const { multiple, hasComments } = this.props;
    const { selectedReasons } = this.state;

    const showReasonDueToNoComments = hasComments === false;

    if (multiple) {
      const reasons = selectedReasons.includes(value) ?
      selectedReasons.filter((item) => item !== value) :
      [...selectedReasons, value];

      return void this.setState({
        selectedReasons: reasons,
        ...(value === OTHER_REASON && !showReasonDueToNoComments ? { otherReason: '' } : {})
      });
    }

    this.setState({
      selectedReasons: [value],
      ...(value !== OTHER_REASON && !showReasonDueToNoComments ? { otherReason: '' } : {})
    });
  });

  resetState = () => {
    this.setState(INITIAL_STATE);
  };

  onInputChange = ({ target: { value } }) => {
    this.setState({ otherReason: value });
  };

  getSelectedReasons = () => {
    const { selectedReasons, otherReason } = this.state;

    const { hasComments } = this.props;

    if (hasComments === false) {
      return otherReason !== '' && selectedReasons.length ? [otherReason] : [];
    }

    return [
    ...selectedReasons,
    ...(selectedReasons.includes(OTHER_REASON) ? [otherReason] : [])].
    filter((reason) => Boolean(reason) && reason !== OTHER_REASON);
  };

  onSave = () => {
    const { onSave, multiple } = this.props;

    const selectedReasons = this.getSelectedReasons();

    const value = multiple ? selectedReasons : selectedReasons[0];

    onSave(value);
  };

  render() {
    const {
      visible,
      saveText,
      stayOpen,
      onClose,
      reasons,
      title,
      subtitle,
      additionalReasonTitle,
      columns,
      multiple,
      allowOther,
      hasComments
    } = this.props;

    const { otherReason, selectedReasons } = this.state;
    const totalReasons = this.getSelectedReasons();

    return (
      <FormModal
        visible={visible}
        onClose={onClose}
        title={title}
        subtitle={subtitle}
        saveText={saveText}
        onSave={this.onSave}
        stayOpenOnSave={stayOpen}
        saveDisabled={!totalReasons.length}>

        <ChangesForm
          reasons={reasons}
          additionalReasonTitle={additionalReasonTitle}
          columns={columns}
          multiple={multiple}
          allowOther={allowOther}
          otherReason={otherReason}
          selectedReasons={selectedReasons}
          onCheck={this.onCheck}
          onInputChange={this.onInputChange}
          hasComments={hasComments} />

      </FormModal>);

  }
}

export default ChangesModal;